<template>
  <div>
    <el-input placeholder="请输入商品名称"
              v-model="query.productName"
              style="width: 280px;margin-bottom: 10px;">
      <el-button slot="append"
                 icon="el-icon-search"
                 @click="handleCurrentChange(1)"></el-button>
    </el-input>
    <el-table v-loading="loading"
              border
              height="455px"
              :row-class-name="tableRowClassName"
              :data="list">
      <el-table-column label="产品名称"
                       show-overflow-tooltip=""
                       min-width="240"
                       prop="productName">
        <template slot-scope="{ row }">
          <el-link type="primary"
                   style="font-size: 12px"
                   @click="selectItem(row)">{{ row.productName }}</el-link>
        </template>
      </el-table-column>
      <el-table-column label="商品备注"
                       show-overflow-tooltip=""
                       min-width="180"
                       prop="productNameRemark">
      </el-table-column>
      <el-table-column label="商品类型"
                       show-overflow-tooltip=""
                       min-width="100"
                       prop="categoryName">
      </el-table-column>
      <el-table-column label="备案时间"
                       width="120"
                       show-overflow-tooltip="">
        <template slot-scope="{row}">
          {{ row.createdTime | dateformat('YYYY-MM-DD')}}
        </template>
      </el-table-column>
    </el-table>
    <el-pagination style="text-align:center"
                   background
                   @current-change="handleCurrentChange"
                   :current-page.sync="query.pageNum"
                   :page-size="query.pageSize"
                   layout="total, prev, pager, next"
                   :total="total">
    </el-pagination>
  </div>
</template>
<script>
export default {
  name: 'spec-table',
  components: { },
  props: {
    config: { type: Object, default () { return { vendorId: null, vendorName: '', productId: null, productName: '' } } }
  },
  data () {
    return {
      loading: false,
      query: { pageNum: 1, pageSize: 10, productName: '' },
      total: 0,
      list: []
    }
  },
  methods: {
    tableRowClassName ({ row }) {
      return row.productId === this.config.productId ? 'current-select-row' : ''
    },
    selectItem (row) {
      const { productId, productName } = row
      this.$emit('update', { productId, productName }, 2)
    },
    handleCurrentChange (current) {
      this.query.pageNum = current
      this.fetchList()
    },
    fetchList () {
      this.loading = true
      this.$$ProductApi.getproducts({ ...this.query, vendorId: this.config.vendorId })
        .then(res => {
          const { result, message, total, records } = res.data
          this.loading = false
          if ([0, 13].includes(result)) {
            this.total = total
            this.list = records
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          console.log(err)
        })
    }
  }
}
</script>
